/*
 * Filename: cq-template.tsx
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import { CQAppConstant } from '../../app-constants';
import { ITemplateProps } from './ITemplate.interface';

const CQTemplate = (props: ITemplateProps) => {
    const { templateItem } = props;
    const history = useHistory();
    const navigateToTemplateConfigPage = () => {
        props.setSelectedTemplate({ selectedTemplate: templateItem });
        history.push(CQAppConstant.NAVIGATION.TEMPLATES_CONFIGURATION);
    };

    return (
        <div key={templateItem.label} className="slds-col slds-size_6-of-12 slds-medium-size_4-of-12 slds-large-size_3-of-12 slds-m-bottom_small"
            onClick={(evt) => { navigateToTemplateConfigPage(); }} >
            <div className="slds-app-launcher__tile slds-text-link_reset">
                <div className="slds-app-launcher__tile-figure">
                    <span className="slds-avatar slds-avatar_large">
                        <abbr className="slds-avatar__initials slds-icon-custom-7" title="Sales Cloud">
                            <i className="cq-icon-connected_apps"></i>
                        </abbr>
                    </span>
                </div>
                <div className="slds-app-launcher__tile-body">
                    <h2 className="slds-text-heading_medium">{templateItem.label}</h2>
                    <p className="slds-line-clamp_small">{templateItem.description}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CQTemplate;
